import { TableOperations } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableWithPaginationFilteringSorting';

export const hasFilterApplied = (dataOperations?: TableOperations): boolean => {
	return Object.keys(dataOperations?.filter ?? {}).length > 0;
};
